import angular from 'angular';

angular.module('cxSettings', ['commonServices', 'cxHttpServices']);
